export default __webpack_public_path__ + "static/media/storageUnit1-afterA-1024w.5a959e41.png";